import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import StatusIndicator from 'components/StatusIndicator';
import useStyles from 'components/StatusMessage/StatusMessage.styles';
import { Status } from 'features/Frames/types';
import { stateColour } from 'features/Status/utils/state';
import { statusMessageWriter } from 'features/Status/utils/status';

type TableCollapsedContentProps = {
  status: Status | null;
  isExpanded?: boolean;
};
const StatusMessage = ({ status, isExpanded }: TableCollapsedContentProps) => {
  const classes = useStyles({ statusColour: stateColour(status?.state) });

  return (
    <>
      {status && (
        <div className={classes.container}>
          <div className={classes.content}>
            <StatusIndicator color={stateColour(status?.state)} />
            <Typography
              variant="body2"
              fontWeight={isExpanded ? 700 : 'inherit'}
              className={classes.statusMessage}
            >
              {statusMessageWriter(status)}
            </Typography>
          </div>
        </div>
      )}
    </>
  );
};

export default StatusMessage;
